const ActionType = (actionType) => `PAGE_${actionType}`;

export const CHAT_ONLY = ActionType('CHAT_ONLY');
export const INDEX = ActionType('INDEX');
export const TRENDING = ActionType('TRENDING');
export const TRENDING_ITEM = ActionType('TRENDING_ITEM');
export const VIRAL = ActionType('VIRAL');
export const VIRAL_ITEM = ActionType('VIRAL_ITEM');
export const VIRAL_CLIP = ActionType('VIRAL_CLIP');
export const VIRAL_CLIP_ITEM = ActionType('VIRAL_CLIP_ITEM');
export const VOD = ActionType('VOD');
export const VOD_MOVIE = ActionType('VOD_MOVIE');
export const VOD_SERIES = ActionType('VOD_SERIES');
export const VOD_SERIES_SEASON = ActionType('VOD_SERIES_SEASON');
export const VOD_SERIES_EPISODE = ActionType('VOD_SERIES_EPISODE');
export const VOD_SERIES_SEASON_EPISODE = ActionType('VOD_SERIES_SEASON_EPISODE');
export const VOD_ITEM = ActionType('VOD_ITEM');
export const WATCH = ActionType('WATCH');
export const WATCH_CHANNEL = ActionType('WATCH_CHANNEL');
export const DESKTOP = ActionType('DESKTOP');
